export default __webpack_public_path__ + "static/media/warning.45bfb589.gif";